
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Attachment extends Vue {
  @Prop() prefix!: string;
  @Prop() content!: string;
}
